/* Custom Video With Text — "Full width autoplay" layout.
   Lazy-loads the video for the current breakpoint when the section scrolls into view,
   pauses it off-screen, wires the pause/play button and respects prefers-reduced-motion.
   Scoped per section ([data-video-full]); safe to load more than once. */
(function () {
  if (window.CustomVideoFull) {
    window.CustomVideoFull.initAll();
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 798px)');
  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.getAttribute('data-video-ready')) return;
    root.setAttribute('data-video-ready', 'true');

    var videos = Array.prototype.slice.call(root.querySelectorAll('video[data-video]'));
    if (!videos.length) return;

    var toggle = root.querySelector('[data-video-toggle]');
    var inView = false;
    // reduced motion: never autoplay, the visitor starts it with the play button
    var userPaused = reduceQuery.matches;

    function current() {
      var wanted = mobileQuery.matches ? 'mobile' : 'desktop';
      for (var i = 0; i < videos.length; i++) {
        if (videos[i].getAttribute('data-video') === wanted) return videos[i];
      }
      return videos[0];
    }

    function setState(playing) {
      root.classList.toggle('is-playing', playing);
      if (toggle) {
        toggle.setAttribute(
          'aria-label',
          toggle.getAttribute(playing ? 'data-label-pause' : 'data-label-play') || ''
        );
      }
    }

    function sync() {
      var active = current();
      videos.forEach(function (video) {
        if (video !== active && !video.paused) video.pause();
      });

      if (inView && !userPaused) {
        if (!active.getAttribute('src')) {
          active.setAttribute('src', active.getAttribute('data-src'));
          active.load();
        }
        var attempt = active.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {
            setState(false);
          });
        }
      } else if (!active.paused) {
        active.pause();
      }
    }

    videos.forEach(function (video) {
      video.muted = true;
      video.addEventListener('playing', function () {
        video.classList.add('is-ready');
        if (video === current()) setState(true);
      });
      video.addEventListener('pause', function () {
        if (video === current()) setState(false);
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !current().paused;
        // a click is an explicit request: play even if the observer has not fired yet
        if (!userPaused) inView = true;
        sync();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
          });
          sync();
        },
        { threshold: 0.25 }
      ).observe(root);
    } else {
      inView = true;
      sync();
    }

    var onBreakpoint = function () {
      sync();
    };
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', onBreakpoint);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(onBreakpoint);
    }

    setState(false);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-video-full]');
    Array.prototype.forEach.call(nodes, init);
  }

  window.CustomVideoFull = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
